/**
 * VILLAPLUS — MÓDULO JS MAESTRO
 * Todas las interacciones custom del proyecto viven en este archivo.
 * Namespace: window.Villaplus
 */
(function () {
  'use strict';

  window.Villaplus = window.Villaplus || {};

  /* ---------------------------------------------------------------------
     UTILIDAD COMPARTIDA: Reveal on scroll (IntersectionObserver)
     Aplica a cualquier elemento con clase .vp-reveal / .vp-reveal-left /
     .vp-reveal-right / .vp-reveal-scale en toda la landing.
     --------------------------------------------------------------------- */
  Villaplus.initRevealObserver = function () {
    var targets = document.querySelectorAll(
      '.vp-reveal, .vp-reveal-left, .vp-reveal-right, .vp-reveal-scale'
    );
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  };

  /* ---------------------------------------------------------------------
     HEADER (referencia — ya inicializado desde header-villaplus.liquid)
     Se mantiene el método aquí para que todo el JS del proyecto viva
     en un único archivo fuente.
     --------------------------------------------------------------------- */
  Villaplus.initHeader = Villaplus.initHeader || function () {
    var header = document.querySelector('[data-vp-header]');
    if (!header) return;
    var lastScroll = window.scrollY;

    window.addEventListener(
      'scroll',
      function () {
        var current = window.scrollY;
        header.classList.toggle('is-scrolled', current > 40);
        header.classList.toggle(
          'is-hidden',
          current > lastScroll && current > 160
        );
        lastScroll = current;
      },
      { passive: true }
    );
  };

  /* ---------------------------------------------------------------------
     HEADER — menú móvil (burger)
     --------------------------------------------------------------------- */
  Villaplus.initHeaderBurger = function () {
    var burger = document.querySelector('[data-vp-burger]');
    var nav = document.querySelector('[data-vp-mobile-nav]');
    if (!burger || !nav) return;

    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  };

  /* ---------------------------------------------------------------------
     HERO
     --------------------------------------------------------------------- */
  Villaplus.initHero = function () {
    var hero = document.querySelector('[data-vp-hero]');
    if (!hero) return;

    /* La entrada del título/descripción/botones/media es 100% CSS
       (@keyframes) — ver villaplus-custom.css → 02. HERO. No requiere
       JS para ser visible, así el Hero nunca depende de que este
       script cargue correctamente. Desde aquí solo se controla la
       interactividad: video, mute y botones magnéticos. */

    /* Video: play / pause / mute con soporte de video nativo de
       Shopify (deferred_media) o <video> con MP4 propio. */
    var wrapper = hero.querySelector('[data-vp-hero-video-wrapper]');
    var video = hero.querySelector('[data-vp-hero-video]');
    var playBtn = hero.querySelector('[data-vp-hero-play]');
    var muteBtn = hero.querySelector('[data-vp-hero-mute]');

    if (video) {
      var prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      var trySyncPlayingState = function () {
        wrapper.classList.toggle('is-playing', !video.paused && !video.ended);
      };

      /* --- FIX 1: refuerzo de atributos para iOS ------------------------
         Safari en iPhone a veces ignora el atributo HTML "muted" si la
         propiedad JS no queda fijada explícitamente antes de play().
         También reforzamos "playsinline"/"webkit-playsinline" vía JS. */
      var reinforceAttributes = function () {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
      };

      /* --- FIX 2: desbloqueo por gesto -----------------------------------
         Si el intento de autoplay inicial es bloqueado por el sistema
         (Modo de Bajo Consumo, Modo de Datos Bajos, o el permiso de
         Auto-Reproducción de Safari para el sitio), NO hay forma de
         forzarlo por código sin un gesto real del usuario. En vez de
         obligar a tocar el botón de play del video específicamente, se
         escucha el PRIMER gesto en cualquier parte de la página (scroll,
         tap, clic) y se reintenta reproducir en ese instante — como casi
         todo usuario interactúa con la página en el primer segundo, esto
         se siente como autoplay real en la enorme mayoría de los casos. */
      var gestureUnlockAttached = false;
      var attachGestureUnlock = function () {
        if (gestureUnlockAttached) return;
        gestureUnlockAttached = true;

        var unlock = function () {
          if (video.paused) {
            reinforceAttributes();
            var retryPromise = video.play();
            if (retryPromise && retryPromise.then) {
              retryPromise.then(trySyncPlayingState).catch(function () {
                /* Sigue bloqueado (poco común llegado a este punto):
                   se deja visible el botón de play para inicio manual. */
              });
            }
          }
        };

        ['touchstart', 'pointerdown', 'scroll', 'click'].forEach(function (evt) {
          document.addEventListener(evt, unlock, { once: true, passive: true });
        });
      };

      var attemptAutoplay = function () {
        reinforceAttributes();

        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.then(trySyncPlayingState).catch(function () {
            /* Autoplay bloqueado por el navegador/sistema: se deja
               visible el botón de play y se prepara el desbloqueo por
               gesto para el primer touch/scroll/clic del usuario. */
            wrapper.classList.remove('is-playing');
            attachGestureUnlock();
          });
        }
      };

      /* En mobile el video NUNCA se autorreproduce: se evita así la
         descarga pesada del archivo en conexiones de datos móviles.
         Se muestra el poster (o el primer frame) y el usuario puede
         darle play manualmente con el botón si quiere verlo. */
      var isDesktopViewport = window.matchMedia('(min-width: 768px)').matches;
      var wantsAutoplay = video.dataset.vpAutoplayIntent === 'true';

      if (wantsAutoplay && isDesktopViewport && !prefersReducedMotion) {
        if (video.readyState >= 2) {
          attemptAutoplay();
        } else {
          video.addEventListener('loadedmetadata', attemptAutoplay, { once: true });
          /* Red de seguridad: si "loadedmetadata" no llega a tiempo
             (p. ej. Modo de Datos Bajos suprime la precarga), se
             reintenta igual pasado un breve margen. */
          window.setTimeout(function () {
            if (video.paused) attemptAutoplay();
          }, 600);
        }
      }

      /* Mantiene el icono de sonido sincronizado con el estado real
         del video, sin importar qué lo haya cambiado (botón de mute,
         botón de play, o el desbloqueo por gesto). */
      var syncMuteUI = function () {
        if (!muteBtn) return;
        muteBtn.classList.toggle('is-unmuted', !video.muted);
        muteBtn.setAttribute(
          'aria-label',
          video.muted ? 'Activar sonido del video' : 'Silenciar video'
        );
      };

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (video.paused) {
            /* Clic real del usuario: se puede activar el sonido sin
               que el navegador lo bloquee (a diferencia del autoplay). */
            video.muted = false;
            video.play();
          } else {
            video.pause();
          }
        });
      }

      video.addEventListener('play', trySyncPlayingState);
      video.addEventListener('pause', trySyncPlayingState);
      video.addEventListener('volumechange', syncMuteUI);
      syncMuteUI();

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
        });
      }

      /* Pausa el video fuera de viewport para ahorrar recursos */
      if ('IntersectionObserver' in window) {
        var visibilityObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting && !video.paused) {
                video.dataset.vpWasPlaying = 'true';
                video.pause();
              } else if (
                entry.isIntersecting &&
                video.dataset.vpWasPlaying === 'true'
              ) {
                video.play();
                video.dataset.vpWasPlaying = '';
              }
            });
          },
          { threshold: 0.2 }
        );
        visibilityObserver.observe(wrapper);
      }
    }

    /* 3. Botones magnéticos: pequeño desplazamiento hacia el cursor */
    var magneticButtons = hero.querySelectorAll('.vp-btn--magnetic');
    var isFinePointer = window.matchMedia('(pointer: fine)').matches;

    if (isFinePointer) {
      magneticButtons.forEach(function (btn) {
        var strength = 0.25;

        btn.addEventListener('mousemove', function (e) {
          var rect = btn.getBoundingClientRect();
          var relX = e.clientX - rect.left - rect.width / 2;
          var relY = e.clientY - rect.top - rect.height / 2;
          btn.style.setProperty('--mx', (relX * strength).toFixed(1));
          btn.style.setProperty('--my', (relY * strength).toFixed(1));
        });

        btn.addEventListener('mouseleave', function () {
          btn.style.setProperty('--mx', 0);
          btn.style.setProperty('--my', 0);
        });
      });
    }
  };

  /* ---------------------------------------------------------------------
     ANTES Y DESPUÉS — slider de comparación
     100% nativo: Pointer Events (cubre mouse + touch + stylus con la
     misma API) + soporte de teclado (flechas) para accesibilidad.
     El contenido (ambas imágenes, posición 50% por defecto) ya es
     visible vía CSS sin este script; acá solo se agrega la interacción.

     REGLA DE GESTOS (mobile):
     - Mouse / pen: arrastra el divisor desde cualquier punto de la
       tarjeta, como siempre.
     - Touch sobre la manija (.vp-ba__handle): arrastra el divisor.
       La manija tiene touch-action:none en CSS, así que el navegador
       nunca compite por ese gesto.
     - Touch en el resto de la imagen: si el dedo se levanta sin
       moverse (tap), el divisor salta a ese punto. Si el dedo se
       mueve (swipe), el gesto queda 100% libre para que el navegador
       haga scroll nativo del carrusel .vp-ba__track — el script no
       llama a preventDefault en ningún momento, así que nunca hay
       conflicto con el scroll-snap horizontal en mobile.
     --------------------------------------------------------------------- */
  Villaplus.initBeforeAfter = function () {
    var sliders = document.querySelectorAll('[data-vp-ba-slider]');
    if (!sliders.length) return;

    var TAP_THRESHOLD = 8; // px de tolerancia para distinguir tap de swipe

    sliders.forEach(function (slider) {
      var handle = slider.querySelector('[data-vp-ba-handle]');
      if (!handle) return;

      var setPosition = function (clientX) {
        var rect = slider.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        slider.style.setProperty('--pos', pct + '%');
        handle.setAttribute('aria-valuenow', Math.round(pct));
      };

      var pointer = {
        id: null,
        startX: 0,
        startY: 0,
        dragging: false,
        onHandle: false
      };

      var cleanup = function () {
        pointer.id = null;
        pointer.dragging = false;
        slider.classList.remove('is-dragging');
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
        window.removeEventListener('pointercancel', onPointerCancel);
      };

      var onPointerMove = function (e) {
        if (e.pointerId !== pointer.id) return;

        if (!pointer.dragging) {
          var dx = Math.abs(e.clientX - pointer.startX);
          var dy = Math.abs(e.clientY - pointer.startY);
          if (dx < TAP_THRESHOLD && dy < TAP_THRESHOLD) return;

          /* Touch fuera de la manija que se movió lo suficiente para
             ser un swipe: se suelta el control, el navegador se
             encarga de mover el carrusel. */
          if (e.pointerType === 'touch' && !pointer.onHandle) {
            cleanup();
            return;
          }

          pointer.dragging = true;
          slider.classList.add('is-dragging');
        }

        setPosition(e.clientX);
      };

      var onPointerUp = function (e) {
        if (e.pointerId !== pointer.id) return;

        if (!pointer.dragging) {
          /* Tap simple, sin arrastre real: salta el divisor a ese punto. */
          setPosition(e.clientX);
        }

        cleanup();
      };

      var onPointerCancel = function (e) {
        if (e.pointerId !== pointer.id) return;
        cleanup();
      };

      slider.addEventListener('pointerdown', function (e) {
        pointer.id = e.pointerId;
        pointer.startX = e.clientX;
        pointer.startY = e.clientY;
        pointer.dragging = false;
        pointer.onHandle = !!(e.target.closest && e.target.closest('[data-vp-ba-handle]'));

        /* Mouse / pen: arrastra de inmediato desde cualquier punto,
           igual que antes. Touch: espera a ver si es tap o swipe. */
        if (e.pointerType !== 'touch') {
          pointer.dragging = true;
          slider.classList.add('is-dragging');
          setPosition(e.clientX);
        }

        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        window.addEventListener('pointercancel', onPointerCancel);
      });

      /* Accesibilidad: control por teclado sobre la manija */
      handle.setAttribute('role', 'slider');
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');

      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
        var step = 5;
        if (e.key === 'ArrowLeft') {
          current = Math.max(0, current - step);
        } else if (e.key === 'ArrowRight') {
          current = Math.min(100, current + step);
        } else {
          return;
        }
        e.preventDefault();
        slider.style.setProperty('--pos', current + '%');
        handle.setAttribute('aria-valuenow', current);
      });
    });
  };

  /* ---------------------------------------------------------------------
     ANTES Y DESPUÉS — carrusel mobile + paginación en puntos + autoplay
     Progresivo: el carrusel ya es 100% funcional por scroll nativo sin
     este script; acá se sincroniza el punto activo y, si el schema
     define un intervalo (data-vp-ba-autoplay > 0), se agrega avance
     automático solo en el layout mobile/tablet.
     --------------------------------------------------------------------- */
  Villaplus.initBeforeAfterDots = function () {
    var groups = document.querySelectorAll('[data-vp-ba]');
    groups.forEach(function (section) {
      var track = section.querySelector('[data-vp-ba-track]');
      var dotsWrap = section.querySelector('[data-vp-ba-dots]');
      if (!track || !dotsWrap) return;

      var cards = track.querySelectorAll('[data-vp-ba-card]');
      var dots = dotsWrap.querySelectorAll('[data-vp-ba-dot]');
      if (!cards.length || !dots.length) return;

      var activeIndex = 0;

      var goTo = function (index) {
        if (!cards[index]) return;
        cards[index].scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      };

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var index = Array.prototype.indexOf.call(cards, entry.target);
                activeIndex = index;
                dots.forEach(function (d) { d.classList.remove('is-active'); });
                if (dots[index]) dots[index].classList.add('is-active');
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        cards.forEach(function (card) { observer.observe(card); });
      }

      /* --- Autoplay opcional --------------------------------------- */
      var autoplaySeconds = parseFloat(section.getAttribute('data-vp-ba-autoplay')) || 0;
      if (autoplaySeconds <= 0 || cards.length < 2) return;

      var timer = null;
      var userInteracted = false;

      var isCarouselActive = function () {
        /* Coincide con el breakpoint donde el track pasa a ser
           carrusel horizontal (ver CSS → 07. RESPONSIVE). */
        return window.matchMedia('(max-width: 1024px)').matches;
      };

      var stop = function () {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      var tick = function () {
        if (!isCarouselActive() || userInteracted) {
          stop();
          return;
        }
        activeIndex = (activeIndex + 1) % cards.length;
        goTo(activeIndex);
      };

      var start = function () {
        stop();
        if (!isCarouselActive() || userInteracted) return;
        timer = window.setInterval(tick, autoplaySeconds * 1000);
      };

      /* Se detiene definitivamente ante la primera interacción manual
         del usuario, para no pelear con su gesto. */
      var stopForGood = function () {
        userInteracted = true;
        stop();
      };

      track.addEventListener('pointerdown', stopForGood, { passive: true });
      track.addEventListener('wheel', stopForGood, { passive: true });
      dotsWrap.addEventListener('pointerdown', stopForGood, { passive: true });

      window.addEventListener('resize', function () {
        if (isCarouselActive() && !userInteracted) {
          start();
        } else {
          stop();
        }
      });

      start();
    });
  };

  /* ---------------------------------------------------------------------
     LIGHTBOX DE FOTOS — Nuestros servicios / Equípate con lo mejor
     Al tocar una tarjeta, su foto se abre en grande. No se llama a
     preventDefault en ningún gesto táctil, así que el zoom nativo con
     los dedos sobre la imagen ampliada sigue funcionando solo.
     --------------------------------------------------------------------- */
  Villaplus.initServiceLightbox = function () {
    var triggers = document.querySelectorAll('[data-vp-lightbox-trigger]');
    var lightbox = document.querySelector('[data-vp-lightbox]');
    if (!triggers.length || !lightbox) return;

    var img = lightbox.querySelector('[data-vp-lightbox-img]');
    var closeBtn = lightbox.querySelector('[data-vp-lightbox-close]');
    var lastTrigger = null;

    var open = function (trigger) {
      var src = trigger.getAttribute('data-vp-lightbox-src');
      if (!src) return;

      lastTrigger = trigger;
      img.src = src;
      img.alt = trigger.getAttribute('data-vp-lightbox-alt') || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    };

    var close = function () {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      img.src = '';
      if (lastTrigger) lastTrigger.focus();
    };

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(trigger);
        }
      });
    });

    closeBtn.addEventListener('click', close);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) close();
    });
  };

  /* ---------------------------------------------------------------------
     RED DE SEGURIDAD: si por cualquier motivo el IntersectionObserver
     no llega a marcar un elemento como visible (bug, sección fuera de
     cualquier viewport posible, cambio de layout, etc.), se fuerza su
     visibilidad pasado un tiempo prudencial. Esto NO cubre el caso de
     que este archivo .js no cargue en absoluto — para eso existe el
     fallback <noscript> en snippets/vp-noscript-fallback.liquid.
     --------------------------------------------------------------------- */
  Villaplus.initRevealFailSafe = function () {
    window.setTimeout(function () {
      var stuck = document.querySelectorAll(
        '.vp-reveal:not(.is-visible), .vp-reveal-left:not(.is-visible), ' +
        '.vp-reveal-right:not(.is-visible), .vp-reveal-scale:not(.is-visible)'
      );
      stuck.forEach(function (el) { el.classList.add('is-visible'); });
    }, 2500);
  };

  /* ---------------------------------------------------------------------
     INIT
     --------------------------------------------------------------------- */
 document.addEventListener('DOMContentLoaded', function () {
    Villaplus.initHeader();
    Villaplus.initHeaderBurger();
    Villaplus.initRevealObserver();
    Villaplus.initRevealFailSafe();
    Villaplus.initHero();
    Villaplus.initBeforeAfter();
    Villaplus.initBeforeAfterDots();
    if (Villaplus.initCollectionPriceSlider) Villaplus.initCollectionPriceSlider();
    if (Villaplus.initCollectionSidebarAutoSubmit) Villaplus.initCollectionSidebarAutoSubmit();
    Villaplus.initServiceLightbox();
  });
})();